import { MaybeGetter } from "@/types/query-options";

export const resolveMaybeGetter = <T>(source: MaybeGetter<T>): T => {
    if (typeof source === 'function') {
        return (source as () => T)();
    }

    return source;
}
  